import { generateTypes } from 'reducers/utils/HttpReducerHelper';

export const fundingEnquiriesList = generateTypes('FUNDING_ENQUIRY', 'LIST');
